import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input, TextareaCustom } from 'components';
import { domainActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, FindErrorItem, useModal, FindSuccessItem, Images } from 'utils';

export const AddDomain = ({ info, afterSuccess }) => {
    const ACTION_TYPE = info ? 'EDIT_DOMAIN' : 'CREATE_DOMAIN';
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const {
        handleSubmit,
        control,
        setError,
        clearErrors,
        reset,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        if (info) {
            const result = {
                ...info,
            };
            reset(result);
        }
    }, [info]);

    useEffect(() => {
        return () => {
            clearErrors();
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            if (afterSuccess) {
                afterSuccess();
            }
        }
    }, [success]);

    // useEffect(() => {
    //     if (backError?.error?.length) {
    //         if (backError?.error[0] === 'website must be a URL address') {
    //             setError('website', {
    //                 message: 'Website must be a URL address.',
    //             });
    //             dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    //         }
    //     }
    // }, [backError]);

    const handleCreate = (data) => {
        if (info) {
            dispatch(domainActions.editDomain(info.id, data));
        } else {
            dispatch(domainActions.createDomain(data));
        }
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Domain' : 'Add Domain'}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <div className="full-width">
                        <Input
                            name="name"
                            label="Domain Name*"
                            variant="outlined"
                            control={control}
                            maxLength={50}
                            rules={{
                                maxLength: {
                                    value: 50,
                                    message: 'Max length is 50 digits.',
                                },
                                required: 'Domain name is required.',
                            }}
                        />

                        <TextareaCustom
                            control={control}
                            name="description"
                            label="Description"
                            variant={'outlined'}
                            // rules={{
                            //     required: 'Description is required.',
                            // }}
                            // allowCharacter={true}
                            // maxLength={100}
                        />
                    </div>
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
